// validation.js

// Fonction de validation pour l'email
export const validateEmail = (email) => {
    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!email) return { valid: false, error: "L'email est requis" };
    if (!regex.test(email)) return { valid: false, error: "Email invalide" };
    return { valid: true };
  };
  
  // Fonction de validation pour le mot de passe
  export const validatePassword = (password) => {
    if (!password) return { valid: false, error: "Le mot de passe est requis" };
    if (password.length < 8) return { valid: false, error: "Doit contenir au moins 8 caractères" };
    const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).+$/;
    if (!strongPasswordRegex.test(password)) return { valid: false, error: "Doit contenir au moins une majuscule, une minuscule, un chiffre et un symbole" };
      
    return { valid: true };
  };
  export const validatePasswordMinimal = (password) => {
    if (!password) return { valid: false, error: "Le mot de passe est requis" };
      
    return { valid: true };
  };

  // Fonction pour valider la correspondance des mots de passe
export const validatePasswordMatch = (newPassword, confirmPassword) => {
    if (newPassword !== confirmPassword) {
      return { valid: false, error: "Les mots de passe ne correspondent pas." };
    }
    return { valid: true };
  };
  
  // Fonction de validation pour le nom d'utilisateur
  export const validateUsername = (username) => {
    if (!username) return { valid: false, error: "Le nom d'utilisateur est requis" };
    if (username.length < 3) return { valid: false, error: "Le nom d'utilisateur doit contenir au moins 3 caractères" };
    const usernameRegex = /^[a-zA-Z0-9_]+$/;
    if (!usernameRegex.test(username)) return { valid: false, error: "Le nom d'utilisateur ne doit contenir que des lettres, chiffres ou _" };
  
    return { valid: true };
  };

  export const validateUsernameMinimal = (username) => {
    if (!username) return { valid: false, error: "Le nom d'utilisateur est requis" };
    if (username.length < 3) return { valid: false, error: "Le nom d'utilisateur doit contenir au moins 3 caractères" };

    return { valid: true };
  };
  